/* eslint no-console: 'off' */

/**
 * HTTPs requester.
 */
class DataRequestBase {
  get(path) {
    return this.apiRequest(path, 'GET');
  }

  /**
   * Sends a data request.
   */
  request(data) {
    return this.apiRequest(`/request`, 'POST', data);
  }

  /**
   * Sends a generic data request to the server.
   */
  apiRequest(url, method = 'POST', data = null) {
    let stringified = '';
    try {
      stringified = JSON.stringify(data);
    } catch (e) {
      console.error(`Failed to stringify request data`, data);
      throw e;
    }

    let contextError = new Error(`[request] internal server error`);
    return new Promise(resolve => {
      let req = new XMLHttpRequest();
      req.open(method, `/api${url}`, true);

      //Send the proper header information along with the request
      req.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
      req.withCredentials = true;
      req.onreadystatechange = () => {
        let msg =
          `[request] failed URL: ${url}, status: ${req.status}, ` +
          `request: ${data ? JSON.stringify(data) : null}, ` +
          `response: '${req.responseText}'.`;

        if (req.readyState == 4) {
          let status = req.status;
          switch (status) {
            case 200: {
              let response = null;
              try {
                response =
                  (req.responseText && JSON.parse(req.responseText)) || null;
              } catch (e) {
                console.error(e);
                console.error(msg, contextError);
              }
              resolve({ response, status });
              break;
            }

            case 401:
              resolve({ response: null, status });
              break;

            default: {
              console.error(msg, contextError);
              resolve({ response: null, status });
            }
          }
        }
      };
      req.send((data && `data=${encodeURIComponent(stringified)}`) || null);
    });
  }
}

export { DataRequestBase };
